(() => {
  const syncStickyAtc = (bar, sourceBar) => {
    const destinationTitle = bar.querySelector('.bl-mobile-sticky-atc__title');
    const sourceTitle = sourceBar.querySelector('.bl-mobile-sticky-atc__title');
    const destinationPrice = bar.querySelector('.bl-mobile-sticky-atc__price');
    const sourcePrice = sourceBar.querySelector('.bl-mobile-sticky-atc__price');
    const destinationImage = bar.querySelector('.bl-mobile-sticky-atc__image');
    const sourceImage = sourceBar.querySelector('.bl-mobile-sticky-atc__image');
    const destinationButton = bar.querySelector('.bl-mobile-sticky-atc__button');
    const sourceButton = sourceBar.querySelector('.bl-mobile-sticky-atc__button');
    const destinationCheckout = bar.querySelector('[data-bl-sticky-checkout]');
    const sourceCheckout = sourceBar.querySelector('[data-bl-sticky-checkout]');

    if (destinationTitle && sourceTitle) destinationTitle.textContent = sourceTitle.textContent;
    if (destinationPrice && sourcePrice) destinationPrice.textContent = sourcePrice.textContent;
    if (destinationImage && sourceImage) {
      destinationImage.src = sourceImage.src;
      destinationImage.srcset = sourceImage.srcset;
      destinationImage.alt = sourceImage.alt;
    }

    if (destinationButton && sourceButton) {
      destinationButton.disabled = sourceButton.disabled;
      destinationButton.textContent = sourceButton.disabled
        ? sourceButton.textContent.trim()
        : destinationButton.dataset.labelAdd || 'Add to cart';
    }

    if (destinationCheckout && sourceCheckout) {
      destinationCheckout.disabled = sourceCheckout.disabled;
    }
  };

  const syncWithMainButton = (bar, mainButton) => {
    const stickyButton = bar.querySelector('.bl-mobile-sticky-atc__button');
    const checkoutButton = bar.querySelector('[data-bl-sticky-checkout]');
    const mainLabel = mainButton.querySelector('span');

    if (stickyButton) {
      stickyButton.disabled = mainButton.disabled;
      stickyButton.textContent = mainButton.disabled && mainLabel
        ? mainLabel.textContent.trim()
        : stickyButton.dataset.labelAdd || 'Add to cart';
    }
    if (checkoutButton) checkoutButton.disabled = mainButton.disabled;
  };

  const checkoutSelectedVariant = (bar) => {
    const form = document.getElementById(bar.dataset.formId);
    const variantInput = form?.querySelector('input[name="id"]');
    const quantityInput = document.querySelector(`[name="quantity"][form="${bar.dataset.formId}"]`)
      || form?.querySelector('[name="quantity"]');
    const variantId = variantInput?.value;
    const quantity = Math.max(1, Number.parseInt(quantityInput?.value || '1', 10) || 1);

    if (!variantId || variantInput.disabled) return;

    const root = window.Shopify?.routes?.root || '/';
    window.location.assign(`${root}cart/${encodeURIComponent(variantId)}:${quantity}?checkout`);
  };

  const initializeStickyAtc = (root = document) => {
    const bars = root.querySelectorAll ? root.querySelectorAll('[data-bl-sticky-atc]') : [];

    bars.forEach((bar) => {
      if (bar.dataset.blStickyInitialized === 'true') return;
      if (!bar.closest('product-info[id^="MainProduct-"]')) return;

      const mainButton = document.getElementById(bar.dataset.mainButtonId);
      if (!mainButton) return;

      bar.dataset.blStickyInitialized = 'true';
      if (bar.parentElement !== document.body) document.body.append(bar);
      syncWithMainButton(bar, mainButton);

      const checkoutButton = bar.querySelector('[data-bl-sticky-checkout]');
      checkoutButton?.addEventListener('click', () => checkoutSelectedVariant(bar));

      const updateVisibility = () => {
        const shouldShow = mainButton.getBoundingClientRect().bottom < 0 && window.scrollY > 160;
        bar.classList.toggle('is-visible', shouldShow);
      };

      let visibilityFrame;
      const queueVisibilityUpdate = () => {
        if (visibilityFrame) return;
        visibilityFrame = window.requestAnimationFrame(() => {
          visibilityFrame = null;
          updateVisibility();
        });
      };

      const observer = new IntersectionObserver(
        () => updateVisibility(),
        { threshold: 0.2 }
      );

      observer.observe(mainButton);
      window.addEventListener('scroll', queueVisibilityUpdate, { passive: true });
      window.addEventListener('resize', queueVisibilityUpdate, { passive: true });
      updateVisibility();

      if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
        const sectionId = bar.id.replace('BeadLeavesStickyAtc-', '');
        subscribe(PUB_SUB_EVENTS.variantChange, (event) => {
          if (String(event.data.sectionId) !== sectionId) return;

          const sourceBar = event.data.html.getElementById(bar.id)
            || event.data.html.querySelector('[data-bl-sticky-atc]');
          if (sourceBar) syncStickyAtc(bar, sourceBar);
          syncWithMainButton(bar, mainButton);
        });
      }

      const buttonObserver = new MutationObserver(() => syncWithMainButton(bar, mainButton));
      buttonObserver.observe(mainButton, { attributes: true, childList: true, subtree: true });
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initializeStickyAtc());
  } else {
    initializeStickyAtc();
  }

  document.addEventListener('shopify:section:load', (event) => initializeStickyAtc(event.target));

  const productObserver = new MutationObserver(() => initializeStickyAtc());
  productObserver.observe(document.documentElement, { childList: true, subtree: true });
})();
